const regPhone = /^1[0-9]{10}$/
const regPassword = /^(?:\d+|[a-zA-Z]+|[!@#$%^&*]+)$/
const regInteger = /^[0-9]*$/
//有1~2位小数的正实数
const regFloat = /^[0-9]+(.[0-9]{1,2})?$/


export default {
  verifyPhone(phone){
    let flag = false
    if (regPhone.test(phone)) {
	    flag = true
	  }
    return flag
  },
  verifyPassword(password){
  	let flag = false
    if (password.length >= 6) {
	    flag = true
	  }
    return flag
  },
  verifyInteger(amount){
  	let flag = false
    if (regInteger.test(amount)) {
	    flag = true
	  }
    return flag
  },
  verifyFloat(amount){
  	let flag = false
    if (regFloat.test(amount)) {
	    flag = true
	  }
    return flag
  },
  enterIntOrFloat(val){
    // let value = val ? val : ''
    // if(value){
    //   debugger;
    //   if(typeof value != 'string') value.toString()
    //   value = value.replace(/\D|^0+/g,'')
    //   value = value.replace(/^[0]/g,'0')
    // }
    // return value
    if(''!= val.replace(/\d{1,}\.{0,1}\d{0,}/,''))
    {
      val = val.match(/\d{1,}\.{0,1}\d{0,}/) == null ? '' :val.match(/\d{1,}\.{0,1}\d{0,}/);
    }
    return val;
  }
}
